import $ from 'jquery'; // Needed because slinky is a jQuery plugin
import { min992, max992 } from "../utils"; // Use for handling Media Queries

const Misc = () => {

    console.log("misc");
      
}

export default Misc